"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatUsd = void 0;
exports.formatUsd = (amount) => new Intl.NumberFormat("en-us", {
    style: "currency",
    currency: "usd"
}).format(amount);



//////////////////
// WEBPACK FOOTER
// ./src/shared/util/formatUsd.ts
// module id = 2345
// module chunks = 0